const API_URL = process.env.REACT_APP_API_URL;

/* 🔑 SINGLE SOURCE OF TRUTH */
const getToken = () =>
  sessionStorage.getItem("token") ||
  localStorage.getItem("token");

/* ================= STATS ================= */
export const fetchAdminStats = async () => {
  const token = getToken();

  const res = await fetch(`${API_URL}/api/admin/stats`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) throw new Error("Admin stats failed");
  return res.json();
};

/* ================= USERS ================= */
export const fetchAdminUsers = async () => {
  const token = getToken();

  const res = await fetch(`${API_URL}/api/admin/users`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) throw new Error("Admin users failed");

  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

/* ================= SEARCHES ================= */
export const fetchAdminSearches = async () => {
  const token = getToken();

  const res = await fetch(`${API_URL}/api/admin/searches`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) throw new Error("Admin searches failed");

  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const addTokensToUser = async (userId, tokens) => {
  const token = getToken();

  const res = await fetch(`${API_URL}/api/admin/add-tokens`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, tokens }),
  });

  if (!res.ok) throw new Error("Add tokens failed");
  return res.json();
};

export const fetchCuratorApplications = async () => {
  const token = getToken();

  const res = await fetch(`${API_URL}/api/admin/curator-applications`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) throw new Error("Failed to fetch applications");
  return res.json();
};

export const approveCurator = async (id) => {
  const token = getToken();

  await fetch(`${API_URL}/api/admin/curator-approve/${id}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const rejectCurator = async (id) => {
  const token = getToken();

  await fetch(`${API_URL}/api/admin/curator-reject/${id}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
};